export default __webpack_public_path__ + "07963246192eb354ae7fdde475828b8a.svg";